import styled from '@emotion/styled';
import React from 'react';
import { Flex, FlexProps } from 'rebass';
import Button from '../Button/Button'; // type StyledThirdPaneProps = BoxProps & {}

// type StyledThirdPaneProps = BoxProps & {}

// TODO: @Dan help to type the theme
// background: ${(props: any) => {
//   console.log(props)
//   return props.theme.colors.white
// }};

export type ThirdPaneFooterProps = FlexProps;

const ThirdPaneFooter = (props: ThirdPaneFooterProps): JSX.Element => {
  return (
    <Flex
      px={20}
      py={4}
      {...(props as any)}
      sx={{
        borderTop: '1px solid',
        borderTopColor: 'tableBorder',

        background: 'background',

        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2,
        flexGrow: 0,
        flexShrink: 1,

        // horizontal scroll
        whiteSpace: 'nowrap',
        overflowX: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        // button child works,
        // but * loses specificity war
        '> button': {
          verticalAlign: 'middle',
          marginRight: 2,
          flexShrink: 0,
        },
        '> *:last-child': {
          marginRight: 0,
        },

        ...props.sx,
      }}
    >
      {props.children}
    </Flex>
  );
};

export default ThirdPaneFooter;

export const sampleFooterChildren = (
  <>
    <Button>Confirmation Action</Button>
    <Button variant="danger">Destructive Action</Button>
  </>
);
